export default function(state = [], action){
    switch(action.type){
        case "SET_OUTCOME_LIST":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/businessOutcome.js